export default __webpack_public_path__ + "static/media/Professional-support-team.397fc690.svg";